export const CHECKOUT2_CUSTOMER_FORMDATA=`CHECKOUT2_CUSTOMER_FORMDATA`;
export const CHECKOUT2_CUSTOMER_FORMDATA_CLEAR=`CHECKOUT2_CUSTOMER_FORMDATA_CLEAR`;